import React from "react";
import "./Services.css";
import TemporaryFencingImg from "../assets/images/Temporary-Construction-Fence-Rental.jpg";
import EmergencyFenceSetupImg from "../assets/images/Emergency-Fence-Setup.jpg";
import CustomPerimeterPlanningImg from "../assets/images/Custom-Perimeter-Planning.jpg";

const services = [
  {
    title: "Temporary Fencing",
    description:
      "Secure your construction site or event with our durable, easy-to-install temporary fencing solutions.",
    icon: "🛡️",
  },
  {
    title: "Site Hoarding",
    description:
      "Protect your site and maintain privacy with custom hoarding options tailored to your project needs.",
    icon: "🚧",
  },
  {
    title: "Logistics Support",
    description:
      "Streamline your operations with our reliable logistics and on-site coordination services.",
    icon: "🚚",
  },
];

const Services = () => {
  return (
    <>
      {/* Services Section */}
      <section style={{ backgroundColor: "#1a1a1a" }}>
        <div className="container py-5">
          {/* Section Title */}
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="display-4 text-white fw-normal">
                How We Can Help You
              </h2>
            </div>
          </div>

          {/* Services Cards */}
          <div className="row g-4 mb-5">
            {/* New Builds */}
            <div className="col-lg-4">
              <div
                className="card border-0 h-100 p-4"
                style={{ backgroundColor: "white", backgroundImage: `url(${TemporaryFencingImg})`, backgroundSize: 'cover', backgroundPosition: 'center'   }}
              >
                <div className="card-body">
                  {/* Icon */}
                  <div className="mb-4 text-center">
                    {/* <svg
                      width="80"
                      height="80"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="brand-orange-svg"
                    >
                      <path
                        d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9 22V12H15V22"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7 8H17"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7 12H10"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg> */}
                  </div>

                  <h3 className="h4 mb-4 text-white fs-3 fw-bold">
                    Temporary Construction Fence Rental
                  </h3>
                  <p className="lh-lg text-white fs-5">
                    Protect your crew, control site access, and meet compliance
                    regulations with our heavy-duty panels. Available for
                    short-term and long-term rental.
                  </p>
                </div>
              </div>
            </div>

            {/* Full Renovation */}
            <div className="col-lg-4">
              <div
                className="card border-0 h-100 p-4"
                style={{ backgroundColor: "#2d5128", backgroundImage: `url(${EmergencyFenceSetupImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
              >
                <div className="card-body">
                  {/* Icon */}
                  <div className="mb-4 text-center">
                    {/* <svg
                      width="80"
                      height="80"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="brand-orange-svg"
                    >
                      <path
                        d="M20 7H4C2.89543 7 2 7.89543 2 9V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V9C22 7.89543 21.1046 7 20 7Z"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9 7V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V7"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="2"
                        stroke="#96794e"
                        strokeWidth="2"
                      />
                      <path
                        d="M7 17V21"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M17 17V21"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg> */}
                  </div>

                  <h3 className="h4 text-white mb-4 fs-3 fw-bold">Emergency Fence Setup</h3>
                  <p className="text-white lh-lg fs-5">
                    Need urgent fencing for site hazards or unexpected work
                    zones? Our rapid deployment team is available across
                    Ontario.
                  </p>
                </div>
              </div>
            </div>

            {/* Home Extensions */}
            <div className="col-lg-4">
              <div
                className="card border-0 h-100 p-4"
                style={{ backgroundColor: "white", backgroundImage: `url(${CustomPerimeterPlanningImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
              >
                <div className="card-body">
                  {/* Icon */}
                  <div className="mb-4 text-center">
                    {/* <svg
                      width="80"
                      height="80"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="brand-orange-svg"
                    >
                      <path
                        d="M16 3H21V8"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 3H3V8"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21 16V21H16"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3 16V21H8"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21 8L16 3"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 3L3 8"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16 21L21 16"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 21L3 16"
                        stroke="#96794e"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg> */}
                  </div>

                  <h3 className="h4 mb-4 text-white fs-3 fw-bold">Custom Perimeter Planning</h3>
                  <p className=" lh-lg text-white fs-5">
                    Have unique site dimensions or terrain challenges? We offer
                    tailored fencing layouts and support for complex builds.
                    From residential renovations to multi-million dollar
                    projects - our fences scale with your vision.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Full List Button */}
          {/* <div className="row">
            <div className="col-12 text-center">
              <button className="btn brand-orange-outline px-5 py-3 fw-semibold d-flex align-items-center gap-2 mx-auto">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M3 12L21 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3 6L21 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3 18L21 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Full list of services
              </button>
            </div>
          </div>*/}
        </div>
      </section>
    </>
  );
};

export default Services;
